'use client';

import dynamic from 'next/dynamic';
import LazyLoad from 'react-lazyload';

const ProvenInTheField = dynamic(() => import('./provenInTheField'), { ssr: false });

const ProvenInTheFieldLazyLoad = () => {
  return (
    <LazyLoad
      offset={300}
      once
      placeholder={<div className='min-h-[410px] lg_min-h-[854px]' />}
    >
      <ProvenInTheField />
    </LazyLoad>
  );
};

export default ProvenInTheFieldLazyLoad;
